export const GET_WEB_COUNT = "GET_WEB_COUNT";
export const GET_ANDROID_COUNT = "GET_ANDROID_COUNT";
export const GET_IOS_COUNT = "GET_IOS_COUNT";
